// extracted by mini-css-extract-plugin
export default {"root":"_2iNbIKVD","left":"mRq8R0GR","right":"L61VDyMT","content":"aaIg9jYI","logoBox":"_3mVnJFoU","logoBorder":"_4-PmK3Tr"};